module.exports = __webpack_public_path__ + "img/thumb-norm-holderzy.jpg";